import Button from "components/Buttons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const ContactSpecialistBtn = () => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  let history = useHistory();
  const goContact = () => {
    history.push("/contact");
  };
  return (
    <Button align="center" onClick={goContact}>
      {t("__contact_specialist")}
    </Button>
  );
};

export default ContactSpecialistBtn;
